<template>
  <b-modal
    ref="mgac_kompack"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-0"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="relative p-[20px] pt-[28px]"
    >
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="icon-popup-warning"
        class="w-[100px] h-[100px] mx-auto mb-[24px]"
      >
      <h3 class="text-[18px] text-[#333333] font-semibold text-center">
        {{ title }}
      </h3>
      <p class="text-[#626262] text-[16px] font-normal text-center mb-[28px]">
        {{ message }}
      </p>
      <slot name="default" />
      <div class="flex items-center gap-[8px] mt-[16px]">

        <b-button
          block
          variant="outline-primary"
          @click="hide"
        >
          Batal
        </b-button>
        <b-button
          block
          variant="primary"
          class="!flex items-center justify-center gap-[8px] mt-0"
          :disabled="isLoading || confirmDisabled"
          @click="handleConfirm"
        >
          <b-spinner
            v-if="isLoading"
            variant="light"
            small
          />
          {{ isLoading ? 'Memproses...' : confirmText }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>

/**
 * ModalGeneralAction
 * @description ModalGeneralAction is a component that displays the modal general action
 * @returns {Object} ModalGeneralAction
 */
export default {
  name: 'ModalGeneralAction',
  props: {
    confirmDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '',
      message: '',
      isLoading: false,
      confirmText: 'Simpan',
    }
  },
  created() {
    this.onConfirm = () => {}
  },
  methods: {
    handleConfirm() {
      this.isLoading = true
      this.onConfirm({
        hide: this.hide,
        setIsLoading: this.setIsLoading,
      })
    },
    setIsLoading(value) {
      this.isLoading = value
    },
    /**
     * Show the modal general action, this function would be called by the parent component to show the modal
     * @param {Object} params - The parameters
     * @param {String} params.title - The title
     * @param {String} params.message - The message
     * @param {String} params.confirmText - The confirm text
     * @param {Function} params.onConfirm - The on confirm
     */
    show({
      title,
      message,
      confirmText,
      onConfirm,
    }) {
      this.resetForm()
      this.title = title
      this.message = message
      this.confirmText = confirmText || 'Simpan'
      this.onConfirm = onConfirm
      this.$refs.mgac_kompack.show()
    },
    /**
     * Hide the modal general action
     */
    hide() {
      this.resetForm()
      this.$refs.mgac_kompack.hide()
    },
    /**
     * Reset the form
     */
    resetForm() {
      this.title = ''
      this.message = ''
      this.confirmText = 'Simpan'
      this.onConfirm = () => {}
    },
  },
}
</script>
